import styled from 'styled-components';
import omitProps from 'ggApp/utils/omitProps';
import { transition } from 'ggApp/utils/mixins';

export const BoxContainer = styled.div`
    position: relative;

    &:not(:last-child) {
        margin: 0 0 8px;
    }
`;

export const Icon = styled.div`
    position: absolute;
    right: 16px;
    top: 16px;
    fill: ${({ theme }) => theme.colors['Level 3']};
    cursor: pointer;
    z-index: 2;

    &:hover {
        fill: ${({ theme }) => theme.colors.Foreground};
    }
`;

export const Box = styled(omitProps('active', 'readOnly')('div'))`
    position: relative;
    padding: 16px;
    background-color: ${({ active, theme }) => active && theme.colors['Level 1']};
    border: 2px solid ${({ active, theme }) => (active ? 'transparent' : theme.colors['Level 1'])};
    border-radius: 8px;
    pointer-events: auto;

    &:hover {
        cursor: ${({ readOnly }) => !readOnly && 'pointer'};
        background-color: ${({ readOnly, theme }) => !readOnly && theme.colors['Level 2']};
    }

    ${transition('background-color', 'medium-desktop', 'standard')};
`;

export const BoxTitle = styled.p`
    ${({ theme }) => theme.typography.SmallHeadline};
    /* color: ${({ theme }) => theme.colors['Level 4']}; */
    margin-bottom: 8px;
`;

export const PaymentNameWrap = styled.div`
    margin: 0 0 4px;
    display: flex;
    align-items: center;

    & > svg {
        margin-right: 8px;
        min-width: 24px;
    }
`;

export const Text = styled.p`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors['Level 5']};
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const DeliveryBlock = styled.p`
    ${({ theme }) => theme.typography.TinyParagraph};
    margin-top: -4px;
    margin-bottom: 8px;
    color: ${({ theme }) => theme.colors['Level 4']};
`;

export const WarningWrapper = styled.div`
  ${({ theme }) => theme.typography.TinyParagraph};
  display: flex;
  margin: 8px 0 8px;
  padding: 8px;
  font-size: 14px;
  text-align: left;
  color: #EDA210;
  border-radius: 8px;
  transition: background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s;
  background-color: ${({ theme }) => theme.colors.cautionBackground};
`;

export const Message = styled.div`
  padding-left: 8px;
`;
